import api from './api';

export const getFuncionarios = async () => {
  const { data } = await api.get('/funcionarios');
  return data;
};

export const updateFuncionario = async (codFunc, payload) => {
  const { data } = await api.put('updatefunc', { ...payload, codFunc });
  return data;
};

export const signupFuncionario = async (cpf, senha) => {
  const { data } = await api.post('funcsignup', { cpf, senha });
  return data;
};

export const buscarMedicos = async (nome) => {
  if (!nome) {
    return [];
  }

  const { data } = await api.get('/medicos/search', {
    params: { nome },
  });

  return data;
};

export const gravarMedico = async (payload) => {
  const { data } = await api.post('medicos', payload);
  return data;
};
